<template>
  <div>
    <div class="invoice" v-show="invoiceVO.id">
      <div class="titleRow">
        <div class="circleYellow"></div>
        <div v-if="type==1 || type==3" class="titleText">{{$t('commission.applyInvoice.invoiceInfo.title')}}</div>
        <div v-else class="titleText">{{$t('commission.commissionDetail.applyInvoice')}}</div>
        <div class="right_icon" v-if="$route.path!='/manager/statistics/newMeeting' && type!=1">
          <pt-icon v-if="!isEdit && showOpration" @click.native="otherStartEdit"  style="font-size: 16px;color: #666" type="icon-bianji1"
                   :title="$t('baseVO.edit')"></pt-icon>
          <a-button v-if="isEdit" @click="cacelClick" size="small" style="margin-right: 5px;">
            {{$t('baseVO.cacel')}}
          </a-button>
          <a-button v-if="isEdit" :loading="saveLoading" type="primary" @click="updateInvoice" size="small">{{$t('baseVO.save')}}</a-button>
        </div>
        <div class="right_icon" v-if="type==1"  @click="showInvoice = !showInvoice">
          <a-icon type="caret-up" v-show="showInvoice"/>
          <a-icon type="caret-down" v-show="!showInvoice"/>
        </div>
      </div>

      <div style="margin-bottom: 20px;margin-top: 20px;" v-if="!isEdit && showInvoice ">
        <a-row style="background: #FAFBFC;border-radius: 4px;padding: 15px 10px 15px 30px;">
          <a-col :span="8">
            <div>
              <div class="title">{{$t('commission.applyInvoice.invoiceInfo.code')}}</div>
              <div class="value" v-text="invoiceVO.code"></div>
            </div>
          </a-col>
          <a-col :span="10">
            <div class="title">{{$t('commission.applyInvoice.invoiceInfo.blankName')}}</div>
            <div class="value" v-text="invoiceVO.blankName"></div>
          </a-col>
          <a-col :span="4">
            <div class="title">{{$t('commission.applyInvoice.invoiceInfo.blankDeposit')}}</div>
            <div class="value" v-text="invoiceVO.blankDeposit"></div>
          </a-col>
          <a-col :span="1">
            <div class="right_icon" v-if="$route.path!='/manager/statistics/newMeeting'">
              <pt-icon v-if="!isEdit && type == 1" @click.native="isEdit = true"  style="font-size: 16px;color: #666" type="icon-bianji1"
                       :title="$t('baseVO.edit')"></pt-icon>
              <a-button v-if="isEdit" @click="cacelClick" size="small" style="margin-right: 5px;">
                {{$t('baseVO.cacel')}}
              </a-button>
              <a-button v-if="isEdit" :loading="saveLoading" type="primary" @click="updateInvoice" size="small">{{$t('baseVO.save')}}</a-button>
            </div>
          </a-col>
          <a-col style="margin-top: 15px;" :span="8">
            <div class="title">{{$t('commission.applyInvoice.invoiceInfo.phone')}}</div>
            <div class="value" v-text="invoiceVO.phone"></div>
          </a-col>
          <a-col style="margin-top: 15px;" :span="16">
            <div class="title">{{$t('commission.applyInvoice.invoiceInfo.address')}}</div>
            <div class="value" v-text="invoiceVO.address"></div>
          </a-col>
        </a-row>
      </div>
      <div style="margin-bottom: 20px;margin-top: 20px;padding: 7.5px;" v-if="isEdit && showInvoice">
        <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
          <a-button v-if="isEdit && type == 1" @click="cacelClick" size="small" style="margin-right: 5px;">
            {{$t('baseVO.cacel')}}
          </a-button>
          <a-button v-if="isEdit && type == 1" :loading="saveLoading" type="primary" @click="updateInvoice" size="small">{{$t('baseVO.save')}}</a-button>
        </div>
        <a-form-model ref="ruleForm" :model="invoiceVO">
          <a-row :gutter="15" style="background-color:   rgba(248,249,251,0.62);border-radius: 4px;padding: 15px 10px">
            <a-col :span="8">
              <a-form-model-item :label="$t('commission.applyInvoice.invoiceInfo.code')" prop="code"
                                 :rules="[{required: true,message:$t('baseVO.inputPlaceholder')}]" class="required">
                <a-input  :maxLength="120" v-model="invoiceVO.code" :placeholder="$t('baseVO.inputPlaceholder')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('commission.applyInvoice.invoiceInfo.blankName')" prop="blankName"
                                 :rules="[{required: true,message:$t('baseVO.inputPlaceholder')}]" class="required">
                <a-input  :maxLength="120" v-model="invoiceVO.blankName" :placeholder="$t('baseVO.inputPlaceholder')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('commission.applyInvoice.invoiceInfo.blankDeposit')" prop="blankDeposit"
                                 :rules="[{required: true,message:$t('baseVO.inputPlaceholder')}]" class="required">
                <a-input  :maxLength="120" v-model="invoiceVO.blankDeposit" :placeholder="$t('baseVO.inputPlaceholder')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('commission.applyInvoice.invoiceInfo.phone')" prop="phone"
                                 :rules="[{required: true,message:$t('baseVO.inputPlaceholder')}]" class="required">
                <a-input  :maxLength="120" v-model="invoiceVO.phone" :placeholder="$t('baseVO.inputPlaceholder')"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="16">
              <a-form-model-item :label="$t('commission.applyInvoice.invoiceInfo.address')" prop="address"
                                 :rules="[{required: true,message:$t('baseVO.inputPlaceholder')}]" class="required">
                <a-input  :maxLength="120" v-model="invoiceVO.address" :placeholder="$t('baseVO.inputPlaceholder')"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
  import invoiceInfoApi from '@/api/mine/invoiceInfo'
  import userApi from '@/api/sys/user'
  export default {
    name: 'invoice',
    props: {
      id: {
        type: String,
        required: true
      },
      type: {
        type: Number,
        required: true
      },
      showOpration:{
        type:Boolean,
        default:true,
      }
    },
    data() {
      return {
        isEdit: false,
        saveLoading: false,
        invoiceVO: {
          blankName: '',
          blankDeposit: '',
          phone: '',
          code: '',
          address: ''
        },
        showInvoice:false,
      }
    },
    watch: {
      id(newValue) {
        this.getData()
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      otherStartEdit(){
        this.isEdit = true
      },
      startEdit(){
        this.isEdit = true
      },
      cacelClick(){
        this.getData()
        this.$nextTick(
        this.isEdit = false
        )
      },

      initFormToken(){
        userApi.getFormToken().then(res=>{
          if(res.code == 1){
            this.invoiceVO.formToken = res.data;
          }
        })
      },
      getData() {
        if (this.id) {
          invoiceInfoApi.getByBusinessIdAndType(this.id, this.type).then(res => {
            if (res.code == 1 && res.data.id) {
              this.invoiceVO = res.data

              if(this.type != 1){
                this.showInvoice = true
              }
              this.initFormToken()
            }
          })
        }

      },
      updateInvoice(){
        this.$refs.ruleForm.validate((valid)=>{
          if(valid){
            invoiceInfoApi.update(this.invoiceVO).then(res=>{
              if(res.code == 1){
                this.isEdit = false;
                this.getData()
                this.$message.success(this.$t('baseVO.saveSuccess'))
              }else{
                this.initFormToken()
              }
            }).catch(()=>{
              this.initFormToken()
            })
          }else{
            this.$message.warn("请正确输入表单")
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .invoice /deep/ .ant-form-item-label{
    line-height: 14px !important;
  }
  .invoice{
    .title{
      font-size: 12px;
      color: #999999;
    }
    .value{
      font-size: 12px;
      color: #333333;
    }
  }
  .titleRow{
    background: #FAFBFC;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    margin-bottom: 5px;
    .circleYellow{
      width: 12px;
      height: 12px;
      background: #FABE00;
      border-radius: 50%;
      margin: 0 10px;
    }
    .right_icon{
      cursor: pointer;
      position: absolute;
      right: 10px;
      color:#CACACA;
      font-size: 12px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .titleText{
      font-size: 14px;
      color: #333333;
      font-weight: bold;
    }
    .right_icon{
      cursor: pointer;
      position: absolute;
      right: 10px;
      color:#CACACA;
      font-size: 12px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>